import { render, staticRenderFns } from "./StripePayment.vue?vue&type=template&id=5b7bb180&"
import script from "./StripePayment.vue?vue&type=script&lang=js&"
export * from "./StripePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports